import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Card } from 'antd';
import JornadasList from 'componentsv2/Jornadas';
import { getGroupMatchDays, getVolleballMatchDetails } from 'api/events';
import { useParams } from 'react-router-dom';
import BlockPageLoader from 'components/Loaders/BlockPageLoader';
import SetsList from 'componentsv2/SetsList';

const JornadasVolleyBall = () => {
  let { matchDayId, groupId, matchId } = useParams();

  const [rounds, setRounds] = useState([]);
  const [loadingGroupRounds, setLoadingGroupRounds] = useState(true);
  const [sets, setSets] = useState({});
  const [loadingSets, setLoadingSets] = useState(true);
  const loading = useMemo(() => loadingSets, [loadingSets]);

  const onLoadSets = useCallback(() => {
    setLoadingSets(true);

    getVolleballMatchDetails(groupId, matchDayId, matchId)
      .then(({ body, status }) => {
        if ([200, 201].includes(status)) {
          setSets(body?.data?.sets || []);
        }

        setLoadingSets(false);
      })
      .catch(() => {
        setLoadingSets(false);
      });
  }, [groupId, matchDayId, matchId]);

  const onLoadRounds = useCallback(() => {
    setLoadingGroupRounds(true);

    getGroupMatchDays(groupId)
      .then(({ body, status }) => {
        if ([200, 201].includes(status)) {
          setRounds(body?.data?.rounds || []);
        }
        setLoadingGroupRounds(false);
      })
      .catch(() => {
        setLoadingGroupRounds(false);
      });
  }, [groupId]);

  useEffect(() => {
    onLoadRounds();
  }, [groupId, onLoadRounds]);

  useEffect(() => {
    onLoadSets();
  }, [onLoadSets]);

  const uniqueRound = rounds?.find(round => {
    return round?.id === Number(matchDayId);
  });

  const match = uniqueRound?.matches?.find(match => match?.id === Number(matchId));

  if (loadingGroupRounds || loading) {
    return <BlockPageLoader className="min-h-screen" valignTop />;
  }

  return (
    <Card title={'Editar Encuentro'}>
      <JornadasList
        displayOnly={true}
        isEdit={false}
        key={match?.id}
        match={match}
        onLoadRounds={onLoadRounds}
        onLoadSets={onLoadSets}
      />

      <div
        style={{
          marginTop: '34px',
          marginBottom: '34px',
          fontSize: '26px',
          display: 'flex',
          justifyContent: 'center',
        }}
        className="avatar-status-name"
      >
        MARCADOR POR SETS
      </div>
      {Object.values(sets)?.map((set, index) => {
        return (
          <SetsList
            key={index}
            onLoadRounds={onLoadRounds}
            onLoadSets={onLoadSets}
            index={index + 1}
            match={match}
            set={set}
          />
        );
      })}
    </Card>
  );
};

export default JornadasVolleyBall;
